import { Box, SimpleGrid} from "@chakra-ui/react";
import ReviewerListTable from "./components/ReviewerListTable";

const ReviewerList = () => 
{

    return (                         

        <Box pt={{ base: "5px", md: "5px", xl: "5px" }}>


            <SimpleGrid>
                <ReviewerListTable/>
            </SimpleGrid>
        </Box>       
    );

};
  
export default ReviewerList;
